import React from 'react';
import BaseForm from '../../../../components/form/BaseForm';
import RadioGroup from '../../../../components/input/RadioGroup';
import InputForm from '../../../../components/form/InputForm';
import {
  BALANCE_PERIOD_TYPE,
  MAXIMUM_MONTHLY_BALANCE_DAY,
  MAXIMUM_MONTHLY_BALANCE_PERIOD,
  MINIMUM_MONTHLY_BALANCE_DAY,
  MINIMUM_MONTHLY_BALANCE_PERIOD,
  BALANCE_DETAIL_PERIOD_TYPE_SELECT_LIST,
} from '../../../../constants/service/app/balanceConstants';
import { formRequiredRules } from '../../../../lib/formRules';

const BrandDetailInfoBalancePeriodInfo = (props) => {
  const { form, balancePeriodInfoList = [], setData, isEditable } = props;

  return (
    <div>
      {balancePeriodInfoList
        .filter(({ management }) => management === null)
        .map((item, index) => (
          <div key={item.id}>
            <BaseForm
              label="정산주기"
              content={
                <RadioGroup
                  className="balance-period-type"
                  disabled={!isEditable}
                  value={item.balancePeriodType ?? BALANCE_PERIOD_TYPE.DAILY}
                  onChange={(value) =>
                    setData({
                      path: [index, 'balancePeriodType'],
                      value,
                    })
                  }
                  list={BALANCE_DETAIL_PERIOD_TYPE_SELECT_LIST}
                />
              }
            />

            {item.balancePeriodType === BALANCE_PERIOD_TYPE.MONTHLY ? (
              <div>
                <BaseForm
                  label="월간 정산일"
                  content={
                    <InputForm
                      form={form}
                      name={`balanceDay_${item.management}`}
                      type="number"
                      rules={[formRequiredRules(true, '필수 값 입니다.', false)]}
                      min={MINIMUM_MONTHLY_BALANCE_DAY}
                      max={MAXIMUM_MONTHLY_BALANCE_DAY}
                      disabled={!isEditable}
                      addonAfter="일"
                      initialValue={item.balanceDay}
                      onChange={(value) =>
                        setData({
                          path: [index, 'balanceDay'],
                          value,
                        })
                      }
                    />
                  }
                />
                <BaseForm
                  className="monthly-balance-period"
                  label="월간 정산주기"
                  content={
                    <InputForm
                      form={form}
                      name={`balancePeriod_${item.management}`}
                      type="number"
                      rules={[formRequiredRules(true, '필수 값 입니다.', false)]}
                      min={MINIMUM_MONTHLY_BALANCE_PERIOD}
                      max={MAXIMUM_MONTHLY_BALANCE_PERIOD}
                      disabled={!isEditable}
                      addonAfter="개월마다"
                      initialValue={item.balancePeriod}
                      onChange={(value) =>
                        setData({
                          path: [index, 'balancePeriod'],
                          value,
                        })
                      }
                    />
                  }
                />
              </div>
            ) : null}
          </div>
        ))}
    </div>
  );
};

export default BrandDetailInfoBalancePeriodInfo;
